import isFunction from 'lodash/isFunction'
import React, { type FunctionComponent } from 'react'
import type { FieldAttributes, FieldProps as FieldPropsCore } from 'formik'
import { Field as FieldCore } from 'formik'
import type { FieldEditorComponentProps } from './FieldEditor'
import { FieldEditor } from './FieldEditor'
import { TextInput } from '@ztechapps/webui.input'

export type FormFieldProps = FieldAttributes<any> & {
  component: FunctionComponent<FieldEditorComponentProps>
  help: string
  showHelpAsInline?: boolean
  label: string
  horizontalLayout?: boolean
  horizontalFormLabelWidth?: number
}

export const Field = ({
  component,
  name,
  onChange: _onChange,
  onBlur: _onBlur,
  help,
  showHelpAsInline,
  label,
  horizontalLayout,
  horizontalFormLabelWidth,
  ...rest
}: FormFieldProps) => {
  component = component ?? TextInput
  return (
    <FieldCore name={name} {...rest}>
      {(fieldProps: FieldPropsCore) => {
        let onChange = _onChange
        let onBlur = _onBlur

        const handleNativeForm = (e, type: 'onChange' | 'onBlur' = 'onChange') => {
          if (e?.target?.value) {
            return fieldProps.field[type](e)
          } else {
            return fieldProps.field[type]({ target: { value: e } } as any)
          }
        }

        if (onChange) {
          if (!isFunction(onChange)) {
            onChange = (e) => fieldProps.form.setFieldValue(name, e)
            onBlur = (e) => fieldProps.form.setFieldTouched(name, e)
          } else {
            //we need to handle the case where the onChange is a function
            onChange = (e, meta) => {
              _onChange(e, meta, fieldProps)
              return handleNativeForm(e)
            }
            onBlur = (e, meta) => {
              _onBlur?.(e, meta, fieldProps)
              // return fieldProps.field.onBlur(e)
              return handleNativeForm(e, 'onBlur')
            }
          }
        } else {
          onChange = fieldProps.field.onChange
          onBlur = fieldProps.field.onBlur
        }

        return (
          <FieldEditor
            onChange={onChange}
            onBlur={onBlur}
            name={name}
            componentProps={rest}
            component={component}
            fieldProps={fieldProps}
            help={help}
            showHelpAsInline={showHelpAsInline}
            label={label}
            horizontalFormLabelWidth={horizontalFormLabelWidth}
            horizontalLayout={horizontalLayout}
          />
        )
      }}
    </FieldCore>
  )
}
